import { USER } from '@synthetica-ai/constants';
import { ofType } from '@synthetica-ai/system';
import { localStorageValue } from '@synthetica-ai/utils/storage';
import { combineEpics } from 'redux-observable';
import { iif } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { checkToken } from 'models/user';
import { emptyAction } from 'utils/epics';
import * as actions from './actions';
const user = localStorageValue(USER);
const hasUser = () => user.get();
const startApplicationEpic = (action$) => action$.pipe(ofType(actions.startApplication), mergeMap(() => iif(hasUser, [checkToken()], emptyAction())));
export default combineEpics(startApplicationEpic);
